import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmGetStartedRoute: InvariantJiraRoute = {
	name: 'csm-get-started',
	path: '/jira/customer-service-management/projects/:projectKey/get-started',
	exact: true,
};
